(() => {
  'use strict';
  if (window.whiteConversionLoaded) return;
  window.whiteConversionLoaded = true;
  const collections = new WeakMap();
  const homes = new WeakMap();
  const galleries = new WeakMap();
  const cleanups = new Map();
  let serial = 0;
  const all = (root, selector) => Array.from(root.querySelectorAll(selector));
  const cells = grid => Array.from(grid.children).filter(node => node.matches('.cell'));
  const text = (node, value) => { if (node && node.textContent !== value) node.textContent = value; };
  const button = (label, attr) => {
    const node = document.createElement('button');
    node.type = 'button'; node.textContent = label;
    if (attr) node.setAttribute(attr, '');
    return node;
  };
  function remember(root, cleanup) {
    if (!cleanups.has(root)) cleanups.set(root, []);
    cleanups.get(root).push(cleanup);
  }
  function prune() {
    cleanups.forEach((list, root) => {
      if (!root.isConnected) { list.forEach(fn => fn()); cleanups.delete(root); }
    });
  }
  function openDialog(dialog, opener) {
    if (!dialog || !dialog.showModal || dialog.open) return;
    const other = all(document, 'dialog[open], [role="dialog"][aria-modal="true"]').some(node =>
      node !== dialog && !node.hidden && node.getClientRects().length > 0);
    if (other) return;
    dialog.addEventListener('close', () => {
      if (opener && opener.isConnected) opener.focus();
    }, { once: true });
    dialog.showModal();
  }
  function setupHome(tabs) {
    const grid = document.getElementById('bs-grid');
    if (!grid) return;
    if (homes.has(tabs)) { homes.get(tabs)(); return; }
    const buttons = all(tabs, '[data-filter]');
    tabs.classList.add('home-filter-tabs');
    tabs.setAttribute('role', 'tablist');
    let count = grid.parentElement.querySelector('.bs-result-label');
    if (!count) { count = document.createElement('p'); count.className = 'bs-result-label'; grid.before(count); }
    count.setAttribute('role', 'status'); count.setAttribute('aria-live', 'polite');
    grid.setAttribute('role', 'tabpanel');
    function paint() {
      const chosen = buttons.find(b => b.getAttribute('aria-selected') === 'true') || buttons[0];
      buttons.forEach((b, i) => {
        if (!b.id) b.id = 'white-home-tab-' + i;
        b.setAttribute('role', 'tab'); b.setAttribute('aria-controls', grid.id);
        b.setAttribute('aria-selected', String(b === chosen)); b.tabIndex = b === chosen ? 0 : -1;
      });
      if (chosen) {
        grid.setAttribute('aria-labelledby', chosen.id);
        text(count, chosen.textContent.trim() + ' · ' + cells(grid).filter(c => !c.hidden).length + ' pieces');
      }
    }
    homes.set(tabs, paint);
    const observer = new MutationObserver(paint);
    observer.observe(grid, { childList: true });
    remember(tabs, () => observer.disconnect());
    paint();
  }
  // Colour filter: while Gold / Silver is active, a card shows its first matching
  // variant (image, price, link, quick add). Clearing the filter restores the card.
  function finishData(card) {
    if (!('finishVariants' in card.dataset)) return null;
    if (card.__finishData === undefined) {
      try { card.__finishData = JSON.parse(card.dataset.finishVariants) || null; } catch (_) { card.__finishData = null; }
    }
    return card.__finishData;
  }
  function swapFinish(card, active) {
    const data = finishData(card);
    if (!data) return;
    const pick = active.map(f => data[f]).filter(Boolean).sort((a, b) => a.pos - b.pos)[0] || null;
    const key = pick ? String(pick.id) : '';
    if ((card.__finishKey || '') === key) return;
    const img = card.querySelector('.cell__media img');
    const row = card.querySelector('.cell__row');
    const add = card.querySelector('.cell__add');
    const links = all(card, 'a[href]');
    if (!card.__finishOrig) {
      const attrs = img ? { src: img.getAttribute('data-white-src') || img.getAttribute('src'), srcset: img.getAttribute('data-white-srcset') || img.getAttribute('srcset'),
        width: img.getAttribute('width'), height: img.getAttribute('height'), style: img.getAttribute('style') } : null;
      card.__finishOrig = { price: card.dataset.price, row: row ? row.innerHTML : null, hrefs: links.map(a => a.getAttribute('href')), img: attrs,
        add: add ? { id: add.getAttribute('data-variant-id'), label: add.getAttribute('aria-label'), text: add.textContent, disabled: add.disabled } : null };
    }
    const o = card.__finishOrig;
    const setAttr = (node, name, value) => { if (value === null || value === undefined) node.removeAttribute(name); else node.setAttribute(name, value); };
    // Restore first, then layer the matched variant on top.
    card.dataset.price = o.price;
    if (row && o.row !== null) row.innerHTML = o.row;
    const rowLinks = all(card, 'a[href]');
    rowLinks.forEach((a, i) => { if (o.hrefs[i] !== undefined) a.setAttribute('href', o.hrefs[i]); });
    // A still-lazy image keeps its data-white-* slots so the runtime reveals the right file.
    const paint = (src, srcset, width, height, style) => {
      const lazy = img.hasAttribute('data-white-src');
      setAttr(img, lazy ? 'data-white-src' : 'src', src);
      setAttr(img, lazy ? 'data-white-srcset' : 'srcset', srcset);
      setAttr(img, 'width', width); setAttr(img, 'height', height); setAttr(img, 'style', style);
    };
    if (img && o.img) paint(o.img.src, o.img.srcset, o.img.width, o.img.height, o.img.style);
    if (add && o.add) { add.setAttribute('data-variant-id', o.add.id); setAttr(add, 'aria-label', o.add.label); add.textContent = o.add.text; add.disabled = o.add.disabled; setAttr(add, 'aria-disabled', o.add.disabled ? 'true' : null); }
    card.__finishKey = key;
    if (!pick) return;
    card.dataset.price = String(pick.p);
    rowLinks.forEach(a => a.setAttribute('href', pick.url));
    const priceLink = row && row.querySelector('.price');
    if (priceLink) {
      // Same markup as the Liquid card: <span class=money> inside the link and inside <s>.
      const money = value => { const m = document.createElement('span'); m.className = 'money'; m.textContent = value; return m; };
      priceLink.replaceChildren(money(pick.price));
      if (pick.cmp) { const s = document.createElement('s'); s.append(money(pick.cmp)); priceLink.append(' ', s); }
      let pct = row.querySelector('.cell__discount');
      if (pick.pct > 0) { if (!pct) { pct = document.createElement('span'); pct.className = 'cell__discount'; row.append(pct); } pct.textContent = '−' + pick.pct + '%'; }
      else if (pct) pct.remove();
    }
    if (img && pick.img) paint(pick.img, pick.srcset, pick.w ? String(pick.w) : o.img.width, pick.h ? String(pick.h) : o.img.height, pick.fit || null);
    if (add) {
      const title = card.querySelector('.cell__title')?.getAttribute('title') || '';
      add.setAttribute('data-variant-id', String(pick.id));
      add.disabled = !pick.av; setAttr(add, 'aria-disabled', pick.av ? null : 'true');
      add.textContent = pick.av ? 'Add to cart' : 'Sold out';
      add.setAttribute('aria-label', pick.av ? 'Add ' + title + ' to cart' : title + ' — sold out');
    }
  }
  function setupCollection(root) {
    const grid = root.querySelector('#col-grid');
    const ui = root.querySelector('[data-white-conversion-filters]');
    if (!grid || !ui) return;
    if (collections.has(root)) { collections.get(root).apply(); return; }
    const order = new Map();
    const finishes = new Set();
    let category = root.querySelector('[data-tabs="#col-grid"] [aria-selected="true"]')?.dataset.filter || 'all';
    let ceiling = 'all', sort = 'original';
    let nextOrder = 0;
    // The curated loader already defines the canonical order of later pages.
    let curated = [];
    try { curated = JSON.parse(root.querySelector('[data-curated-handles]')?.textContent || '[]'); } catch (_) { /* Keep DOM order. */ }
    const curatedOrder = new Map(curated.map((handle, i) => [handle, i]));
    function register() {
      cells(grid).forEach(card => { if (!order.has(card)) order.set(card, nextOrder++); });
    }
    const original = card => curatedOrder.has(card.dataset.handle) ? curatedOrder.get(card.dataset.handle) : curated.length + order.get(card);
    const price = card => card.dataset.price?.trim() && Number.isFinite(Number(card.dataset.price)) ? Number(card.dataset.price) : NaN;
    function chip(key, label) {
      const b = button(label + ' ×'); b.dataset.removeFilter = key;
      b.setAttribute('aria-label', 'Remove ' + label);
      ui.querySelector('.applied-filters').append(b);
    }
    function apply() {
      register();
      const cards = cells(grid);
      const activeFinishes = [...finishes];
      cards.forEach(card => swapFinish(card, activeFinishes));
      let count = 0;
      cards.forEach(card => {
        const tokens = (card.dataset.finishes || '').split('|').map(v => v.trim().toLowerCase()).filter(Boolean);
        // Match exact normalized tokens; never substring-match gold inside white gold.
        const colours = new Set(tokens);
        if (tokens.includes('white gold')) colours.add('silver');
        const value = price(card);
        card.hidden = !((category === 'all' || card.dataset.cat === category) &&
          (!finishes.size || [...finishes].some(f => colours.has(f))) &&
          (ceiling === 'all' || (Number.isFinite(value) && value < Number(ceiling))));
        if (!card.hidden) count++;
      });
      const sorted = [...cards].sort((a, b) => {
        if (sort !== 'original') {
          const av = price(a), bv = price(b);
          if (Number.isFinite(av) !== Number.isFinite(bv)) return Number.isFinite(av) ? -1 : 1;
          if (Number.isFinite(av) && av !== bv) return sort === 'low' ? av - bv : bv - av;
        }
        return original(a) - original(b);
      });
      if (sorted.some((card, i) => card !== cards[i])) sorted.forEach(card => grid.append(card));
      const paged = Number(root.dataset.pages) > 1 && root.dataset.curated !== 'true';
      text(ui.querySelector('[data-results]'), count + ' of ' + cards.length + ' loaded pieces');
      text(ui.querySelector('[data-filter-scope]'), paged ? 'Filters and sort apply to loaded products on this page only. Use pagination for other products.' : 'Filters and sort apply to currently loaded products.');
      ui.querySelector('.empty-result').hidden = count > 0;
      all(ui, '[name="finish"]').forEach(n => { n.checked = finishes.has(n.value); });
      all(ui, '[name="price"]').forEach(n => { n.checked = ceiling === n.value; });
      ui.querySelector('[data-sort]').value = sort;
      all(ui, '[data-quick]').forEach(n => n.setAttribute('aria-pressed', String(n.dataset.quick === '150000' ? ceiling === '150000' : finishes.has(n.dataset.quick))));
      all(root, '[data-tabs="#col-grid"] [data-filter]').forEach(n => {
        n.setAttribute('aria-selected', String(n.dataset.filter === category));
        n.tabIndex = n.dataset.filter === category ? 0 : -1;
      });
      const applied = ui.querySelector('.applied-filters'); applied.replaceChildren();
      if (category !== 'all') {
        const tab = all(root, '[data-tabs="#col-grid"] [data-filter]').find(n => n.dataset.filter === category);
        chip('category', tab?.textContent.trim() || category);
      }
      finishes.forEach(f => chip(f, f === 'gold' ? 'Gold' : 'Silver'));
      if (ceiling !== 'all') chip('price', 'Under ₹' + (Number(ceiling) / 100).toLocaleString('en-IN'));
      if (sort !== 'original') chip('sort', sort === 'low' ? 'Price: low to high' : 'Price: high to low');
      text(ui.querySelector('[data-filter-count]'), applied.children.length ? '(' + applied.children.length + ')' : '');
      text(ui.querySelector('[data-apply]'), 'Show ' + count + ' pieces');
    }
    const state = { apply, click(b) {
      if (b.matches('[data-tabs="#col-grid"] [data-filter]')) category = b.dataset.filter;
      else if (b.hasAttribute('data-quick')) {
        const v = b.dataset.quick;
        if (v === '150000') ceiling = ceiling === v ? 'all' : v;
        else if (finishes.has(v)) finishes.delete(v); else finishes.add(v);
      } else if (b.hasAttribute('data-remove-filter')) {
        const key = b.dataset.removeFilter;
        if (key === 'category') category = 'all';
        else if (key === 'price') ceiling = 'all';
        else if (key === 'sort') sort = 'original';
        else finishes.delete(key);
      } else if (b.hasAttribute('data-reset')) { category = 'all'; finishes.clear(); ceiling = 'all'; sort = 'original'; }
      else if (b.hasAttribute('data-open-filter')) { openDialog(ui.querySelector('.filter-dialog'), b); return; }
      else if (b.hasAttribute('data-apply') || b.hasAttribute('data-close-dialog')) { b.closest('dialog')?.close(); return; }
      else return;
      apply();
      if (!b.isConnected) ui.querySelector('[data-open-filter]').focus();
    }, change(n) {
      if (n.name === 'finish') { if (n.checked) finishes.add(n.value); else finishes.delete(n.value); }
      else if (n.name === 'price') ceiling = n.value;
      else if (n.hasAttribute('data-sort')) sort = n.value;
      else return;
      apply();
    } };
    collections.set(root, state);
    register();
    // Only unknown direct card additions trigger work. Moving known cards for sorting
    // emits childList records too, but cannot re-enter apply through this observer.
    const observer = new MutationObserver(records => {
      if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && node.matches('.cell') && !order.has(node)))) apply();
    });
    observer.observe(grid, { childList: true });
    remember(root, () => observer.disconnect());
    ui.hidden = false; apply();
  }
  function setupGallery(stage) {
    if (galleries.has(stage) || !window.HTMLDialogElement) return;
    const rail = stage.querySelector('.stage__rail');
    if (!rail) return;
    const trigger = button('', 'data-white-zoom');
    trigger.className = 'zoom-trigger'; trigger.setAttribute('aria-haspopup', 'dialog'); trigger.setAttribute('aria-label', 'Enlarge image');
    trigger.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5"></path></svg>';
    stage.append(trigger);
    function selectedImage() {
      const bounds = rail.getBoundingClientRect();
      const center = bounds.left + bounds.width / 2;
      const slides = all(rail, '.stage__slide').filter(s => s.getClientRects().length);
      const slide = slides.sort((a, b) => {
        const ar = a.getBoundingClientRect(), br = b.getBoundingClientRect();
        return Math.abs(ar.left + ar.width / 2 - center) - Math.abs(br.left + br.width / 2 - center);
      })[0];
      if (!slide || slide.querySelector('video, iframe, model-viewer, deferred-media')) return null;
      const img = slide.querySelector('img');
      if (!img || !(slide.dataset.zoomSrc || img.dataset.zoomSrc || img.currentSrc || img.getAttribute('src'))) return null;
      return { src: slide.dataset.zoomSrc || img.dataset.zoomSrc || img.currentSrc || img.src, alt: img.alt || 'Product photograph' };
    }
    const update = () => { trigger.hidden = !selectedImage(); };
    rail.addEventListener('scroll', update, { passive: true });
    rail.addEventListener('load', update, true);
    const observer = new MutationObserver(update);
    observer.observe(rail, { childList: true });
    let dialog;
    trigger.addEventListener('click', () => {
      const source = selectedImage(); if (!source) return;
      if (!dialog) {
        dialog = document.createElement('dialog'); dialog.className = 'zoom-dialog';
        dialog.id = 'white-image-zoom-' + (++serial); dialog.setAttribute('aria-label', 'Product image');
        trigger.setAttribute('aria-controls', dialog.id);
        const top = document.createElement('div'); top.className = 'dialog-top';
        const title = document.createElement('span'); title.textContent = 'Product image';
        const controls = document.createElement('div');
        const zoom = button('Zoom 2×', 'data-zoom'); zoom.setAttribute('aria-pressed', 'false');
        const close = button('×', 'data-close-dialog'); close.setAttribute('aria-label', 'Close image');
        controls.append(zoom, close); top.append(title, controls);
        const pan = document.createElement('div'); pan.className = 'zoom-pan';
        pan.tabIndex = 0; pan.setAttribute('role', 'region'); pan.setAttribute('aria-label', 'Product image; scroll to pan when zoomed');
        const image = document.createElement('img'); image.className = 'zoom-image';
        image.style.display = 'block'; image.style.height = 'auto'; image.style.aspectRatio = 'auto';
        pan.append(image); dialog.append(top, pan); stage.append(dialog);
        close.addEventListener('click', () => dialog.close());
        zoom.addEventListener('click', () => {
          const fittedWidth = image.getBoundingClientRect().width;
          const on = pan.classList.toggle('is-zoomed');
          // Double the fitted image width, rather than two times a wider viewport.
          image.style.width = on ? fittedWidth * 2 + 'px' : '';
          zoom.setAttribute('aria-pressed', String(on)); text(zoom, on ? 'Fit image' : 'Zoom 2×');
        });
        dialog.addEventListener('close', () => { image.removeAttribute('src'); });
      }
      const image = dialog.querySelector('.zoom-image');
      const pan = dialog.querySelector('.zoom-pan');
      pan.classList.remove('is-zoomed'); image.style.width = '';
      image.src = source.src; image.alt = source.alt;
      const zoom = dialog.querySelector('[data-zoom]');
      zoom.setAttribute('aria-pressed', 'false'); text(zoom, 'Zoom 2×');
      openDialog(dialog, trigger);
      if (dialog.open) pan.scrollTo(0, 0);
    });
    galleries.set(stage, true);
    remember(stage, () => { observer.disconnect(); rail.removeEventListener('scroll', update); rail.removeEventListener('load', update, true); if (dialog?.open) dialog.close(); });
    update();
  }
  function init() {
    prune();
    all(document, '[data-tabs="#bs-grid"]').forEach(setupHome);
    all(document, '#collection').forEach(setupCollection);
    all(document, '.stage').forEach(setupGallery);
  }
  // Bubble phase: native category handlers on the buttons have already run.
  document.addEventListener('click', event => {
    const b = event.target.closest('button'); if (!b) return;
    const home = b.closest('[data-tabs="#bs-grid"]');
    if (home) homes.get(home)?.();
    const root = b.closest('#collection');
    if (root) collections.get(root)?.click(b);
  });
  document.addEventListener('change', event => {
    const root = event.target.closest('#collection');
    if (root && event.target.closest('[data-white-conversion-filters]')) collections.get(root)?.change(event.target);
  });
  document.addEventListener('keydown', event => {
    const tabs = event.target.closest('[data-tabs="#bs-grid"], #collection [data-tabs="#col-grid"]');
    if (!tabs) return;
    const buttons = all(tabs, '[data-filter]'), index = buttons.indexOf(event.target);
    if (index < 0) return;
    let next;
    if (event.key === 'ArrowRight') next = (index + 1) % buttons.length;
    else if (event.key === 'ArrowLeft') next = (index + buttons.length - 1) % buttons.length;
    else if (event.key === 'Home') next = 0;
    else if (event.key === 'End') next = buttons.length - 1;
    else return;
    event.preventDefault(); buttons[next].click(); buttons[next].focus();
  });
  document.addEventListener('shopify:section:load', () => queueMicrotask(init));
  document.addEventListener('shopify:section:unload', event => {
    cleanups.forEach((list, root) => {
      if (event.target.contains(root)) { list.forEach(fn => fn()); cleanups.delete(root); }
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();

/* JOB P · sticky cart · 2026-11-01 */
(function () {
  'use strict';
  if (!/^\/($|(collections|products)\/)/.test(location.pathname) || document.querySelector('[data-sticky-cart]')) return;
  const bar = document.createElement('aside');
  bar.className = 'we-cart-bar'; bar.hidden = true; bar.dataset.stickyCart = '';
  bar.setAttribute('aria-label', 'Your bag');
  bar.innerHTML = '<div class="we-cart-bar__inner"><div class="we-cart-bar__summary" role="status" aria-live="polite" aria-atomic="true"><p data-sticky-cart-message></p><div class="we-cart-bar__prices"><s data-sticky-cart-original hidden></s><strong data-sticky-cart-total></strong></div></div><form action="/cart" method="post"><button type="submit" name="checkout" class="flk-checkout btn btn--solid we-cart-bar__checkout">Checkout Now →</button></form><a class="we-cart-bar__bag" href="/cart">View Bag</a></div><span class="we-cart-bar__bundle" data-bundle-msg hidden aria-hidden="true"></span>';
  document.body.append(bar);
  const message = bar.querySelector('[data-sticky-cart-message]');
  const total = bar.querySelector('[data-sticky-cart-total]');
  const original = bar.querySelector('[data-sticky-cart-original]');
  const bundle = bar.querySelector('[data-bundle-msg]');
  let cart = null, settling = false, started = false, timer = 0, revision = 0, frame = 0;
  const money = cents => new Intl.NumberFormat('en-IN', { style: 'currency', currency: cart?.currency || 'INR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(cents / 100);
  const visible = el => !!el && !el.hidden && getComputedStyle(el).visibility !== 'hidden' && getComputedStyle(el).display !== 'none' && el.getBoundingClientRect().height > 0;
  function position() {
    frame = 0;
    const quick = document.querySelector('.sticky:not(.is-away)');
    let lift = 0;
    if (visible(quick)) lift = Math.max(0, innerHeight - quick.getBoundingClientRect().top + 8);
    bar.style.setProperty('--we-cart-lift', lift + 'px');
    const blocked = [...document.querySelectorAll('.ck-lock,.razorpay-container-visible,iframe.razorpay-checkout-frame,dialog[open],[role="dialog"][aria-modal="true"]')].some(visible);
    bar.classList.toggle('is-obscured', blocked);
    bar.inert = blocked || bar.hidden;
    const space = bar.hidden ? '0px' : Math.ceil(bar.getBoundingClientRect().height + lift + 12) + 'px';
    if (document.body.style.getPropertyValue('--we-cart-space') !== space) document.body.style.setProperty('--we-cart-space', space);
  }
  function queuePosition() { if (!frame) frame = requestAnimationFrame(position); }
  function paint() {
    if (!cart || !Number.isFinite(cart.total_price)) return;
    const count = Number(cart.item_count) || 0;
    bar.hidden = count < 1;
    document.body.classList.toggle('has-we-cart', count > 0);
    let tags = {};
    try { tags = JSON.parse(sessionStorage.getItem('wb:tags2') || '{}'); } catch (_) {}
    let chains = 0, bracelets = 0;
    (cart.items || []).forEach(item => {
      const t = (tags[item.handle] && tags[item.handle].tags) || [];
      if (t.includes('bundle-bracelet') && item.price >= 99900 && item.price <= 129900) bracelets += item.quantity;
      else if (t.includes('bundle-eligible') && item.price <= 199900) chains += item.quantity;
    });
    const applied = (cart.discount_codes || []).some(d => /^OB-[A-Z2-9]{10}$/i.test(d.code || '') && d.applicable === true) && cart.total_price < cart.original_total_price;
    let copy = count + (count === 1 ? ' item in bag' : ' items in bag');
    if (chains && !bracelets) copy = chains + (chains === 1 ? ' chain in bag' : ' chains in bag');
    if (bracelets && !chains) copy = bracelets + (bracelets === 1 ? ' bracelet in bag' : ' bracelets in bag');
    if (settling) copy = 'Updating bag…';
    else if (applied && bundle.dataset.state === 'ok') {
      const offer = bundle.textContent.match(/^Bundle:\s*(.*?)\s+applied/i);
      if (offer) {
        const groups = [...offer[1].matchAll(/(\d+) (chains|bracelets) for/g)];
        const c = groups.filter(m => m[2] === 'chains').reduce((n,m) => n + Number(m[1]),0);
        const b = groups.filter(m => m[2] === 'bracelets').reduce((n,m) => n + Number(m[1]),0);
        if (c && b) copy = '✓ Bundle Applied: ' + c + ' chains + ' + b + ' bracelets';
        else {
          copy = '✓ Bundle Applied: ' + offer[1];
          const extra = (c ? chains : bracelets) - c - b;
          if (extra > 0) copy += ' + ' + extra + ' more';
        }
      }
    }
    else if (chains === 1 && !bracelets) copy = '1 chain in bag · Add 1 more chain for 2 for ₹1,999';
    else if (bracelets === 1 && !chains) copy = '1 bracelet in bag · Add 1 more bracelet for 2 for ₹1,599';
    message.textContent = copy;
    total.textContent = money(cart.total_price);
    original.hidden = !(applied && !settling);
    if (!original.hidden) original.textContent = money(cart.original_total_price);
    bar.dataset.bundleState = settling ? 'pending' : applied ? 'applied' : 'none';
    queuePosition();
  }
  document.addEventListener('white-edit:cart-updated', event => {
    if (!event.detail?.cart) return;
    cart = event.detail.cart;
    const current = ++revision;
    settling = cart.item_count > 0;
    paint();
    if (!started && cart.item_count > 0 && window.__whiteBundle) {
      started = true;
      window.__whiteBundle.run();
    }
    clearTimeout(timer);
    timer = setTimeout(async () => {
      try { if (window.__whiteBundle) await window.__whiteBundle.idle(); } catch (_) {}
      if (current !== revision) return;
      settling = false; paint();
    }, 450);
  });
  const observer = new MutationObserver(records => {
    if (records.some(record => !bar.contains(record.target) && record.target !== bar)) queuePosition();
  });
  observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'hidden', 'style', 'open', 'aria-modal'] });
  window.addEventListener('resize', queuePosition, { passive: true });
  window.addEventListener('scroll', queuePosition, { passive: true });
  if (window.visualViewport) window.visualViewport.addEventListener('resize', queuePosition, { passive: true });
})();
